let initSuburbs = {
	expires: 0,
	fetching: false,
	data: [],
}

const suburbs = (state = initSuburbs, action) => {
	switch (action.type) {
		case 'SUBURBS_REQUEST':
			return {...state, fetching: true}
		case 'SUBURBS_SUCCESS':
			const exp = Math.floor(Date.now() / 1000) + 3600; // current time + 1 hr
			return {expires: exp, fetching: false, data: action.response}
		case 'SUBURBS_FAILURE':
			return {...state, fetching: false}
		default:
			return state;
	}
}

export default suburbs